import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, RadioFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper, StepperFormRow } from "@components";
import { selectPaymentsOut, selectPaymentsOutAmount } from "@redux";

export const PaymentsOut = ({ control }) => {
  const paymentsOutOptions = useSelector(selectPaymentsOut);
  const paymentsOutAmountOptions = useSelector(selectPaymentsOutAmount);

  return (
    <StepperFormRow>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name="PaymOut.0.PaymOut"
        defaultValue="PEN1"
        className="d-none"
      />

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="PaymOut.0.data.paymOut"
          title={trb(i18.Labels.OutPaym)}
          options={paymentsOutOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="PaymOut.0.data.remOut"
          title={trb(i18.Labels.OutRem)}
          options={paymentsOutAmountOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>
    </StepperFormRow>
  );
};
